/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { getHygraphCosmosPageData } from "@cosmos/hygraph-data";
import { CosmosPageHeroAndSectionMetadataQuery, Locale } from "@cosmos/hygraph-schema";
import { getHygraphLocale, getSlugParam } from "@cosmos/next-common";
import { isError } from "@epic-mw/error-types";
import { Metadata } from "next";
import { notFound } from "next/navigation";

import { CosmosPageMetadata } from "../common/page.types";
import { checkValidParams } from "../templates/selector";

const getPageMetadata = async (
	locale: string = Locale.En,
	slug: string,
	previewParam?: string | string[],
): Promise<CosmosPageHeroAndSectionMetadataQuery> => {
	if (!slug) {
		throw new Error("Missing slug");
	}

	const preview = previewParam && typeof previewParam === "string" ? previewParam : undefined;

	const pageData = await getHygraphCosmosPageData(
		"CosmosPageHeroAndSectionMetadata",
		{
			locale: [locale, Locale.En] as Locale[],
			slug,
		},
		preview,
	);

	return pageData;
};

export async function cosmosPageHeroAndSectionMetadata({
	slug: rootSlug = "",
	params,
	searchParams,
	hygraphLocales,
	getAppMetadata,
}: CosmosPageMetadata): Promise<Metadata> {
	const valid = checkValidParams({ params, searchParams });
	if (!valid) {
		return notFound();
	}

	const slugParam = getSlugParam(params);
	const slug = `${rootSlug}${slugParam}`;
	const locale = params.lang;
	let pageData: CosmosPageHeroAndSectionMetadataQuery = {};
	try {
		pageData = await getPageMetadata(getHygraphLocale(hygraphLocales, locale), slug, searchParams.preview);
	} catch (e) {
		console.error("Failed to get cosmosPageHeroAndSectionMetadata()", { error: isError(e) && e.message });
	}
	const metaTags = pageData.cosmosPageHeroAndSection?.metaTags || {};

	return getAppMetadata(metaTags, slug, locale);
}
